import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from 'src/components/modals/SaveSearchModal/SaveSearchModal.module.scss';
import classNames from 'classnames';
import Modal from '../../layouts/Modal/Modal';
import { useEventListeners, useOutsideClick } from '../../../hooks/utils';

export type TrackingListModalProps = {
  isOpen: boolean;
  onClose: () => void;
  items: any[];
};

const TrackingListModal: React.FC<TrackingListModalProps> = ({ isOpen, onClose, items }) => {
  const { t } = useTranslation();
  const modalRef = React.useRef<HTMLDivElement>(null);

  useOutsideClick(modalRef, e => {
    const event = e as MouseEvent;
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose();
    }
  });

  useEventListeners([{ event: 'keydown' }], e => {
    const event = e as KeyboardEvent;
    if (event.key === 'Escape') {
      onClose();
    }
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        ref={modalRef}
        data-overlay-handles-outside="true"
        data-overlay-handles-escape="true"
        className={classNames(styles.root, '!min-w-[320px]')}>
        <div className={classNames(styles.head, '!mb-0')}>
          <span className="py-6 flex justify-center">{t('tracking.shipping_urls')}</span>
        </div>

        <div className={classNames(styles.content, '!py-0 !px-[16px]')}>
          {items.length ? (
            <div className="flex flex-col w-full items-start">
              {items.map(item => (
                <div
                  key={item.tracking_id}
                  className="flex w-full items-center justify-between gap-[12px] py-[12px] border-subtle-bottom">
                  <Link target="_blank" to={item.tracking_url} className="typo-text-14--medium text-primary">
                    {item.tracking_url}
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex w-full items-start justify-center typo-text-14 text-faded py-[12px]">No data</div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TrackingListModal;
